import { OfficeDTO } from "../../core/ControlsApi/api";
import { BaseNomDTO } from "../ClientDTO";
import { AppointmentStatusDTO, ClinicDTO, SchedulerBlockTypeDTO, ServiceDTO } from "../Scheduler/SchedulerClient";


export class SamplingScheduleOptionDTO implements ISamplingScheduleOptionDTO {
    service?: ServiceDTO;
    startDate?: Date | null;
    endDate?: Date | null;
    samplingOffice?: SamplingOfficeDTO;
    office?: OfficeDTO;
    notAvailable?: boolean | null;

    constructor(data?: ISamplingScheduleOptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.samplingOffice = _data["samplingOffice"] ? SamplingOfficeDTO.fromJS(_data["samplingOffice"]) : <any>null;
            this.office = _data["office"] ? OfficeDTO.fromJS(_data["office"]) : <any>null;
            this.notAvailable = _data["notAvailable"] !== undefined ? _data["notAvailable"] : <any>null;
        }
    }

    static fromJS(data: any): SamplingScheduleOptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingScheduleOptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["samplingOffice"] = this.samplingOffice ? this.samplingOffice.toJSON() : <any>null;
        data["office"] = this.office ? this.office.toJSON() : <any>null;
        data["notAvailable"] = this.notAvailable !== undefined ? this.notAvailable : <any>null;
        return data;
    }
}
export class SamplingOfficeDTO implements ISamplingOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    clinic?: ClinicDTO;
    office?: OfficeDTO;
    name?: string | null;

    constructor(data?: ISamplingOfficeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>null;
            this.office = _data["office"] ? OfficeDTO.fromJS(_data["office"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SamplingOfficeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingOfficeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
        data["office"] = this.office ? this.office.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export class PortalScheduleSamplingDTO implements IPortalScheduleSamplingDTO {
    officeId?: number;
    medicalAnalysisBatchId?: number;
    clinicId?: number;
    samplingOffice?: number;
    dateStart?: Date | null;
    dateEnd?: Date | null;
    shoppingCartIdentity?: string;

    constructor(data?: IPortalScheduleSamplingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeId = _data["officeId"] !== undefined ? _data["officeId"] : <any>null;
            this.medicalAnalysisBatchId = _data["medicalAnalysisBatchId"] !== undefined ? _data["medicalAnalysisBatchId"] : <any>null;
            this.clinicId = _data["clinicId"] !== undefined ? _data["clinicId"] : <any>null;
            this.samplingOffice = _data["samplingOffice"] !== undefined ? _data["samplingOffice"] : <any>null;
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>null;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>null;
            this.shoppingCartIdentity = _data["shoppingCartIdentity"] !== undefined ? _data["shoppingCartIdentity"] : <any>null;
        }
    }

    static fromJS(data: any): PortalScheduleSamplingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PortalScheduleSamplingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeId"] = this.officeId !== undefined ? this.officeId : <any>null;
        data["medicalAnalysisBatchId"] = this.medicalAnalysisBatchId !== undefined ? this.medicalAnalysisBatchId : <any>null;
        data["clinicId"] = this.clinicId !== undefined ? this.clinicId : <any>null;
        data["samplingOffice"] = this.samplingOffice !== undefined ? this.samplingOffice : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["shoppingCartIdentity"] = this.shoppingCartIdentity !== undefined ? this.shoppingCartIdentity : <any>null;
        return data;
    }
}

export interface IPortalScheduleSamplingDTO {
    officeId?: number;
    medicalAnalysisBatchId?: number;
    clinicId?: number;
    samplingOffice?: number;
    dateStart?: Date | null;
    dateEnd?: Date | null;
    shoppingCartIdentity?: string;
}




export interface ISamplingOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    clinic?: ClinicDTO;
    office?: OfficeDTO;
    name?: string | null;
}

export interface ISamplingScheduleOptionDTO {
    service?: ServiceDTO;
    startDate?: Date | null;
    endDate?: Date | null;
    samplingOffice?: SamplingOfficeDTO;
    office?: OfficeDTO;
    notAvailable?: boolean | null;
}


export class PatientCalendarDoctorDTO implements IPatientCalendarDoctorDTO {
    id?: number;
    name?: string | null;
    medicalProfile?: ModelEntityDTO;

    constructor(data?: IPatientCalendarDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.medicalProfile = _data["medicalProfile"] ? ModelEntityDTO.fromJS(_data["medicalProfile"]) : <any>null;
        }
    }

    static fromJS(data: any): PatientCalendarDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCalendarDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>null;
        return data;
    }
}

export interface IPatientCalendarDoctorDTO {
    id?: number;
    name?: string | null;
    medicalProfile?: ModelEntityDTO;
}

export class ModelEntityDTO implements IModelEntityDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;

    constructor(data?: IModelEntityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ModelEntityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModelEntityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IModelEntityDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
}

export class BaseDTO implements IBaseDTO {
    id?: number;
    writeRevision?: boolean | null;

    constructor(data?: IBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
        }
    }

    static fromJS(data: any): BaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        return data;
    }
}

export interface IBaseDTO {
    id?: number;
    writeRevision?: boolean | null;
}

export interface IAppointmentDoctorDTO {
    id?: number;
    writeRevision?: boolean | null;
    patientId?: number | null;
    patientName?: string | null;
    patientEmail?: string | null;
    patientIdentityNumber?: string | null;
    patientPhone?: string | null;
    patientBirthDate?: Date | null;
    doctorId?: number | null;
    doctorName?: string | null;
    service?: ServiceDTO;
    startDate?: Date;
    endDate?: Date;
    appointmentStatus?: AppointmentStatusDTO;
    presentationInvestigationType?: BaseDTO;
    clinic?: ClinicDTO;
    officeId?: number | null;
    consultation?: BaseDTO;
    surgeryExecution?: BaseDTO;
    appointmentType?: BaseNomDTO;
    checkUpId?: number | null;
    description?: string | null;
    price?: number | null;
    schedulerBlockType?: SchedulerBlockTypeDTO;
}
export class AppointmentDoctorDTO implements IAppointmentDoctorDTO {
    id?: number;
    writeRevision?: boolean | null;
    patientId?: number | null;
    patientName?: string | null;
    patientEmail?: string | null;
    patientIdentityNumber?: string | null;
    patientPhone?: string | null;
    patientBirthDate?: Date | null;
    doctorId?: number | null;
    doctorName?: string | null;
    service?: ServiceDTO;
    startDate?: Date;
    endDate?: Date;
    appointmentStatus?: AppointmentStatusDTO;
    presentationInvestigationType?: BaseDTO;
    clinic?: ClinicDTO;
    officeId?: number | null;
    consultation?: BaseDTO;
    surgeryExecution?: BaseDTO;
    appointmentType?: BaseNomDTO;
    checkUpId?: number | null;
    description?: string | null;
    price?: number | null;
    schedulerBlockType?: SchedulerBlockTypeDTO;

    constructor(data?: IAppointmentDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : <any>null;
            this.patientName = _data["patientName"] !== undefined ? _data["patientName"] : <any>null;
            this.patientEmail = _data["patientEmail"] !== undefined ? _data["patientEmail"] : <any>null;
            this.patientIdentityNumber = _data["patientIdentityNumber"] !== undefined ? _data["patientIdentityNumber"] : <any>null;
            this.patientPhone = _data["patientPhone"] !== undefined ? _data["patientPhone"] : <any>null;
            this.patientBirthDate = _data["patientBirthDate"] ? new Date(_data["patientBirthDate"].toString()) : <any>null;
            this.doctorId = _data["doctorId"] !== undefined ? _data["doctorId"] : <any>null;
            this.doctorName = _data["doctorName"] !== undefined ? _data["doctorName"] : <any>null;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.appointmentStatus = _data["appointmentStatus"] ? AppointmentStatusDTO.fromJS(_data["appointmentStatus"]) : <any>null;
            this.presentationInvestigationType = _data["presentationInvestigationType"] ? BaseDTO.fromJS(_data["presentationInvestigationType"]) : <any>null;
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>null;
            this.officeId = _data["officeId"] !== undefined ? _data["officeId"] : <any>null;
            this.consultation = _data["consultation"] ? BaseDTO.fromJS(_data["consultation"]) : <any>null;
            this.surgeryExecution = _data["surgeryExecution"] ? BaseDTO.fromJS(_data["surgeryExecution"]) : <any>null;
            this.appointmentType = _data["appointmentType"] ? BaseNomDTO.fromJS(_data["appointmentType"]) : <any>null;
            this.checkUpId = _data["checkUpId"] !== undefined ? _data["checkUpId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.schedulerBlockType = _data["schedulerBlockType"] ? SchedulerBlockTypeDTO.fromJS(_data["schedulerBlockType"]) : <any>null;
        }
    }

    static fromJS(data: any): AppointmentDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["patientId"] = this.patientId !== undefined ? this.patientId : <any>null;
        data["patientName"] = this.patientName !== undefined ? this.patientName : <any>null;
        data["patientEmail"] = this.patientEmail !== undefined ? this.patientEmail : <any>null;
        data["patientIdentityNumber"] = this.patientIdentityNumber !== undefined ? this.patientIdentityNumber : <any>null;
        data["patientPhone"] = this.patientPhone !== undefined ? this.patientPhone : <any>null;
        data["patientBirthDate"] = this.patientBirthDate ? this.patientBirthDate.toISOString() : <any>null;
        data["doctorId"] = this.doctorId !== undefined ? this.doctorId : <any>null;
        data["doctorName"] = this.doctorName !== undefined ? this.doctorName : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["appointmentStatus"] = this.appointmentStatus ? this.appointmentStatus.toJSON() : <any>null;
        data["presentationInvestigationType"] = this.presentationInvestigationType ? this.presentationInvestigationType.toJSON() : <any>null;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
        data["officeId"] = this.officeId !== undefined ? this.officeId : <any>null;
        data["consultation"] = this.consultation ? this.consultation.toJSON() : <any>null;
        data["surgeryExecution"] = this.surgeryExecution ? this.surgeryExecution.toJSON() : <any>null;
        data["appointmentType"] = this.appointmentType ? this.appointmentType.toJSON() : <any>null;
        data["checkUpId"] = this.checkUpId !== undefined ? this.checkUpId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["schedulerBlockType"] = this.schedulerBlockType ? this.schedulerBlockType.toJSON() : <any>null;
        return data;
    }
}


export class PatientCalendarSlotDTO implements IPatientCalendarSlotDTO {
    startDate?: Date;
    endDate?: Date;
    doctor?: PatientCalendarDoctorDTO;

    constructor(data?: IPatientCalendarSlotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.doctor = _data["doctor"] ? PatientCalendarDoctorDTO.fromJS(_data["doctor"]) : <any>null;
        }
    }

    static fromJS(data: any): PatientCalendarSlotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCalendarSlotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>null;
        return data;
    }
}

export interface IPatientCalendarSlotDTO {
    startDate?: Date;
    endDate?: Date;
    doctor?: PatientCalendarDoctorDTO;
}